import { render, staticRenderFns } from "./userstatistic.vue?vue&type=template&id=1fc83273&scoped=true&"
import script from "./userstatistic.vue?vue&type=script&lang=js&"
export * from "./userstatistic.vue?vue&type=script&lang=js&"
import style0 from "./userstatistic.vue?vue&type=style&index=0&id=1fc83273&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc83273",
  null
  
)

export default component.exports